import React from 'react'
import Utils from 'Utils'



class ConsultCategoryItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      category: props.category
    }
  }
  render() {
    return (
      <div class='cols card' style={{ position: 'relative', margin: '5px 0' }} onClick={this.props.onCategoryClicked}>
        <span>{this.state.category.name}</span>
      </div>
    )
  }
}
export default ConsultCategoryItem